<template>
  <div>
    <Search />
    <!-- <Notice /> -->
    <PassportLevel :companyId="companyId" />
    <IntRank :dealerId="dealerId" />
    <MonthChart :companyId="companyId" />
  </div>
</template>

<script>
//import Notice from './notice'
import Search from './search'
import IntRank from './rank/intRank.vue'
import MonthChart from './monthChart.vue'
import PassportLevel from './passportLevel.vue'
export default {
  components: { MonthChart, Search, IntRank, PassportLevel },
  name: 'index',
  data() {
    return {
      dealerId: '',
      companyId: null,
    }
  },
  methods: {},
  created() {
    //this.dealerId = JSON.parse(localStorage.getItem('user')).dealerId
  },
  mounted() {
    this.dealerId = JSON.parse(localStorage.getItem('user')).dealerId
    this.companyId = JSON.parse(localStorage.getItem('user')).companyId
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
